const initialState = {
  purchaseOptions: {}
};

const purchaseOptions = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default purchaseOptions;
